import Vue from 'vue'
import Vuex from 'vuex'
// import custom pathify config (this is optional!)
import pathify from './pathify'

// import helper function
import { make } from 'vuex-pathify'

// setup store
const state = {
  picturegroup: '',
  groupname: '',
  tokenmsgforward: [],
  myname: '',
  myprofilepicture: '',
  mystatus: '',
  mybusiness_id: '',
  chIsactive: '',
  block_friend: {},
  pathsettings: '',
  socketmessage: {},
  socketexpire_login: {},
  socketquickreply: {},
  socketdisablequickreply: {},
  socketdisableapprove: {},
  socketnote: {},
  socketblock: {},
  socketfriend: {},
  socketaccept_friend: {},
  socketremove_request_friend: {},
  socketremove_friend: {},
  socketcreate_group: {},
  socketinvite_group: {},
  socketactive_group: {},
  socketcencel_group: {},
  socketleave_group: {},
  socketupdate_self: {},
  socketupdate_friend: {},
  socketupdate_img: {},
  socketupdate_file: {},
  socket_unsendmessage: {},
  socket_kickmember: {},
  socket_announce: {},
  socket_edittask: {},
  socket_deletetask: {},
  chat_wallpaper: [],
  socket_official_template: {},
  socket_close_webview: {},
  linkmarket: '',
  socket_update_agora: {},
  socket_accept_call: {},
  typeAgoraCall: '',
  socket_switch_richmenu: {},
  socket_switch_keyboard: {},
  socket_drop_menu: {},
  centrifuge_consent: {}
}

const mutations = make.mutations(state)
// use store
Vue.use(Vuex)

// create store
export default new Vuex.Store({

  // use the plugin
  plugins: [
    pathify.plugin
  ],

  // store properties
  state,
  mutations
})



// WEBPACK FOOTER //
// ./src/pathify/store.js